import { render, staticRenderFns } from "./BetslipTotalOdds.vue?vue&type=template&id=c98a22ba&scoped=true"
import script from "./BetslipTotalOdds.vue?vue&type=script&lang=js"
export * from "./BetslipTotalOdds.vue?vue&type=script&lang=js"
import style0 from "./BetslipTotalOdds.vue?vue&type=style&index=0&id=c98a22ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98a22ba",
  null
  
)

export default component.exports